export default __webpack_public_path__ + "static/background-4-045e123bdc762e12cee1a29c8abae2e1.png";